import state from './moduleProjectListState.js'
import mutations from './moduleProjectListMutations.js'
import actions from './moduleProjectListActions.js'
import getters from './moduleProjectListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

